<template>
  <div id="sourceMaterial">
    <div class="commonContainer">
      <div class="tabs">
        <el-tabs v-model="activeName">
          <el-tab-pane label="OOTD素材" name="first"></el-tab-pane>
          <el-tab-pane label="品牌素材" name="second"></el-tab-pane>
          <el-tab-pane label="#拍立学模板" name="third"></el-tab-pane>
        </el-tabs>
      </div>
      <div v-if="activeName === 'first'">
        <div class="filterConditionContainer">
          <el-card class="box-card">
            <div class="filterCondition" >
              <div class="searchIcon">
                <i class="el-icon-search"></i>
              </div>
              <el-form :inline="true" :model="filterForm1" class="filterForm" label-width="98px" v-if="!showFolderDetail1">
                <el-form-item :label="$t('sourceMaterial.theme')" >
                  <el-select v-model="filterForm1.theme" :placeholder="$t('sourceMaterial.chooseTheme')" clearable>
                    <el-option
                      v-for="item in themeOptions"
                      :key="item.itemKey"
                      :label="item.itemValue"
                      :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('sourceMaterial.season')" >
                  <el-select v-model="filterForm1.season" :placeholder="$t('sourceMaterial.chooseSeason')" clearable>
                    <el-option
                      v-for="item in seasonOptions"
                      :key="item.itemKey"
                      :label="item.itemValue"
                      :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="SKU" >
                  <el-input v-model="filterForm1.sku" :placeholder="$t('sourceMaterial.enterSKU')"></el-input>
                </el-form-item>
              </el-form>
              <el-form :inline="true" :model="detailFilterForm1" class="filterForm" label-width="98px" v-if="showFolderDetail1">
                <el-form-item :label="$t('sourceMaterial.fileName')" >
                  <el-input v-model="detailFilterForm1.fileName" :placeholder="$t('sourceMaterial.enterFileName')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('sourceMaterial.fileType')" >
                  <el-select v-model="detailFilterForm1.fileType" :placeholder="$t('sourceMaterial.chooseFileType')" clearable>
                    <el-option
                      v-for="item in fileTypeOptions"
                      :key="item.itemKey"
                      :label="item.itemValue"
                      :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('sourceMaterial.uploadTime')" >
                  <el-date-picker
                    v-model="detailFilterForm1.uploadTime"
                    type="date"
                    :placeholder="$t('sourceMaterial.chooseUploadTime')"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-form>
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="16">
                  <div class="filterBtns">
                    <!--
                    <el-button type="primary" @click="importData">导 入</el-button>
                    <el-button type="primary" @click="exportData">导 出</el-button>
                    -->
                    <!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                    <el-button type="primary" v-if="!showFolderDetail1" @click="onSearch('folder', 1)">{{ $t('search') }}</el-button>
                    <el-button type="primary" v-if="showFolderDetail1" @click="onSearch('detail', 1)">{{ $t('search') }}</el-button>
                    <el-button type="primary" v-if="!showFolderDetail1" @click="onReset('filterForm',1)">{{ $t('reset') }}</el-button>
                    <el-button type="primary" v-if="showFolderDetail1" @click="onReset('detailFilterForm',1)">{{ $t('reset') }}</el-button>

                  </div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </div>
        <div class="tableContainer">
          <el-card class="box-card">
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="12">
                <p class="title">
                  <span @click="showFolderDetail1=false">{{ $t('sourceMaterial.allSourceMaterial') }}</span>
                  <span style="color: #999" v-if="showFolderDetail1">></span>
                  <span style="color: #999" v-if="showFolderDetail1">{{ folderName }}</span>
                </p>
              </el-col>
              <el-col :span="12" v-if="!showFolderDetail1">
                <div class="filterBtns">
                  <el-checkbox v-model="chooseAllFiles1" style="margin-right: 20px">{{ $t('sourceMaterial.chooseAllSourceMaterial') }}</el-checkbox>
                  <el-button type="primary" icon="el-icon-download" @click="downloadSourceMaterial()">{{ $t('sourceMaterial.downloadSourceMaterial') }}</el-button>
                  <el-button type="primary" icon="el-icon-upload" @click="uploadSourceMaterial()">{{ $t('sourceMaterial.uploadSourceMaterial') }}</el-button>
                  <el-button type="primary" icon="el-icon-delete" @click="patchDeleteFiles()">{{ $t('sourceMaterial.patchDelete') }}</el-button>
                  <el-button type="primary" icon="el-icon-plus" @click="onAddFile()">{{ $t('sourceMaterial.createFile') }}</el-button>
                </div>
              </el-col>
              <el-col :span="12" v-if="showFolderDetail1">
                <div class="filterBtns">
                  <el-checkbox v-model="chooseAllDetails1" style="margin-right: 20px">{{ $t('sourceMaterial.chooseAllSourceMaterial') }}</el-checkbox>
                  <el-button type="primary" icon="el-icon-download" @click="downloadSourceMaterial()">{{ $t('sourceMaterial.downloadSourceMaterial') }}</el-button>
                  <el-button type="primary" icon="el-icon-upload" @click="uploadSourceMaterial()" v-if="isAdmin">{{ $t('sourceMaterial.uploadSourceMaterial') }}</el-button>
                  <el-button type="primary" icon="el-icon-delete" @click="patchDeleteDetails()" v-if="isAdmin">{{ $t('sourceMaterial.patchDelete') }}</el-button>
                  <el-button type="primary" icon="el-icon-plus" @click="onAddFile()" v-if="isAdmin">{{ $t('sourceMaterial.createFile') }}</el-button>
                </div>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <div style="margin-top: 20px">
              <ul class="fileList" v-if="!showFolderDetail1">
                <li v-for="(fileItem, index) in fileList1" @click="openFolder(fileItem.id, fileItem.name, 1)">
                  <el-checkbox v-model="fileList1[index].checked"></el-checkbox>
                  <div style="text-align: center">
                    <i class="el-icon-folder fileIcon"></i>
                  </div>
                  <span>{{ fileItem.name }}</span>
                  <el-row type="flex" class="row-bg" justify="space-between" style="margin-top: 10px">
                    <el-col :span="2"><i class="el-icon-delete" @click="deleteFile(fileItem.id)"></i></el-col>
                    <el-col :span="2"><i class="el-icon-download" @click="downloadFile(fileItem.id)"></i></el-col>
                  </el-row>
                </li>
              </ul>
              <ul class="fileList" v-if="showFolderDetail1">
                <li v-for="(detailItem, index) in detailList1">
                  <el-checkbox v-model="detailList1[index].checked"></el-checkbox>
                  <div style="text-align: center">
                    <img src="http://placekitten.com/200/200" alt="" style="width: 100%">
                  </div>
                  <span>{{ detailItem.name }}</span>
                  <el-row type="flex" class="row-bg" justify="space-between" style="margin-top: 10px">
                    <el-col :span="2"><i class="el-icon-delete" @click="deleteDetail(detailItem.id)"></i></el-col>
                    <el-col :span="2"><i class="el-icon-download" @click="downloadDetail(detailItem.id)"></i></el-col>
                  </el-row>
                </li>
              </ul>
            </div>
          </el-card>
        </div>
      </div>
      <div v-if="activeName === 'second'">
        <div class="filterConditionContainer">
          <el-card class="box-card">
            <div class="filterCondition" >
              <div class="searchIcon">
                <i class="el-icon-search"></i>
              </div>
              <el-form :inline="true" :model="filterForm2" class="filterForm" label-width="98px" v-if="!showFolderDetail2">
                <el-form-item :label="$t('sourceMaterial.theme')" >
                  <el-select v-model="filterForm2.theme" :placeholder="$t('sourceMaterial.chooseTheme')" clearable>
                    <el-option
                      v-for="item in themeOptions"
                      :key="item.itemKey"
                      :label="item.itemValue"
                      :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('sourceMaterial.season')" >
                  <el-select v-model="filterForm2.season" :placeholder="$t('sourceMaterial.chooseSeason')" clearable>
                    <el-option
                      v-for="item in seasonOptions"
                      :key="item.itemKey"
                      :label="item.itemValue"
                      :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="SKU" >
                  <el-input v-model="filterForm2.sku" :placeholder="$t('sourceMaterial.enterSKU')"></el-input>
                </el-form-item>
              </el-form>
              <el-form :inline="true" :model="detailFilterForm2" class="filterForm" label-width="98px" v-if="showFolderDetail2">
                <el-form-item :label="$t('sourceMaterial.fileName')" >
                  <el-input v-model="detailFilterForm2.fileName" :placeholder="$t('sourceMaterial.enterFileName')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('sourceMaterial.fileType')" >
                  <el-select v-model="detailFilterForm2.fileType" :placeholder="$t('sourceMaterial.chooseFileType')" clearable>
                    <el-option
                      v-for="item in fileTypeOptions"
                      :key="item.itemKey"
                      :label="item.itemValue"
                      :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('sourceMaterial.uploadTime')" >
                  <el-date-picker
                    v-model="detailFilterForm2.uploadTime"
                    type="date"
                    :placeholder="$t('sourceMaterial.chooseUploadTime')"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-form>
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="16">
                  <div class="filterBtns">
                    <!--
                    <el-button type="primary" @click="importData">导 入</el-button>
                    <el-button type="primary" @click="exportData">导 出</el-button>
                    -->
                    <!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                    <el-button type="primary" v-if="!showFolderDetail2" @click="onSearch('folder', 2)">{{ $t('search') }}</el-button>
                    <el-button type="primary" v-if="showFolderDetail2" @click="onSearch('detail', 2)">{{ $t('search') }}</el-button>
                    <el-button type="primary" v-if="!showFolderDetail2" @click="onReset('filterForm', 2)">{{ $t('reset') }}</el-button>
                    <el-button type="primary" v-if="showFolderDetail2" @click="onReset('detailFilterForm' ,2)">{{ $t('reset') }}</el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </div>
        <div class="tableContainer">
          <el-card class="box-card">
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="12">
                <p class="title">
                  <span @click="showFolderDetail2=false">{{ $t('sourceMaterial.allSourceMaterial') }}</span>
                  <span style="color: #999" v-if="showFolderDetail2">></span>
                  <span style="color: #999" v-if="showFolderDetail2">{{ folderName }}</span>
                </p>
              </el-col>
              <el-col :span="12" v-if="!showFolderDetail2">
                <div class="filterBtns">
                  <el-checkbox v-model="chooseAllFiles2" style="margin-right: 20px">{{ $t('sourceMaterial.chooseAllSourceMaterial') }}</el-checkbox>
                  <el-button type="primary" icon="el-icon-download" @click="downloadSourceMaterial()">{{ $t('sourceMaterial.downloadSourceMaterial') }}</el-button>
                  <el-button type="primary" icon="el-icon-upload" @click="uploadSourceMaterial()">{{ $t('sourceMaterial.uploadSourceMaterial') }}</el-button>
                  <el-button type="primary" icon="el-icon-delete" @click="patchDeleteFiles()">{{ $t('sourceMaterial.patchDelete') }}</el-button>
                  <el-button type="primary" icon="el-icon-plus" @click="onAddFile()">{{ $t('sourceMaterial.createFile') }}</el-button>
                </div>
              </el-col>
              <el-col :span="12" v-if="showFolderDetail2">
                <div class="filterBtns">
                  <el-checkbox v-model="chooseAllDetails2" style="margin-right: 20px">{{ $t('sourceMaterial.chooseAllSourceMaterial') }}</el-checkbox>
                  <el-button type="primary" icon="el-icon-download" @click="downloadSourceMaterial()">{{ $t('sourceMaterial.downloadSourceMaterial') }}</el-button>
                  <el-button type="primary" icon="el-icon-upload" @click="uploadSourceMaterial()" v-if="isAdmin">{{ $t('sourceMaterial.uploadSourceMaterial') }}</el-button>
                  <el-button type="primary" icon="el-icon-delete" @click="patchDeleteDetails()" v-if="isAdmin">{{ $t('sourceMaterial.patchDelete') }}</el-button>
                  <el-button type="primary" icon="el-icon-plus" @click="onAddFile()" v-if="isAdmin">{{ $t('sourceMaterial.createFile') }}</el-button>
                </div>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <div style="margin-top: 20px">
              <ul class="fileList" v-if="!showFolderDetail2">
                <li v-for="(fileItem, index) in fileList2" @click="openFolder(fileItem.id, fileItem.name, 2)">
                  <el-checkbox v-model="fileList2[index].checked"></el-checkbox>
                  <div style="text-align: center">
                    <i class="el-icon-folder fileIcon"></i>
                  </div>
                  <span>{{ fileItem.name }}</span>
                  <el-row type="flex" class="row-bg" justify="space-between" style="margin-top: 10px">
                    <el-col :span="2"><i class="el-icon-delete" @click="deleteFile(fileItem.id)"></i></el-col>
                    <el-col :span="2"><i class="el-icon-download" @click="downloadFile(fileItem.id)"></i></el-col>
                  </el-row>
                </li>
              </ul>
              <ul class="fileList" v-if="showFolderDetail2">
                <li v-for="(detailItem, index) in detailList2">
                  <el-checkbox v-model="detailList2[index].checked"></el-checkbox>
                  <div style="text-align: center">
                    <img src="http://placekitten.com/200/200" alt="" style="width: 100%">
                  </div>
                  <span>{{ detailItem.name }}</span>
                  <el-row type="flex" class="row-bg" justify="space-between" style="margin-top: 10px">
                    <el-col :span="2"><i class="el-icon-delete" @click="deleteDetail(detailItem.id)"></i></el-col>
                    <el-col :span="2"><i class="el-icon-download" @click="downloadDetail(detailItem.id)"></i></el-col>
                  </el-row>
                </li>
              </ul>
            </div>
          </el-card>
        </div>
      </div>
      <div v-if="activeName === 'third'">
        <div class="filterConditionContainer">
          <el-card class="box-card">
            <div class="filterCondition" >
              <div class="searchIcon">
                <i class="el-icon-search"></i>
              </div>
              <el-form :inline="true" :model="filterForm3" class="filterForm" label-width="98px" v-if="!showFolderDetail3">
                <el-form-item :label="$t('sourceMaterial.theme')" >
                  <el-select v-model="filterForm3.theme" :placeholder="$t('sourceMaterial.chooseTheme')" clearable>
                    <el-option
                      v-for="item in themeOptions"
                      :key="item.itemKey"
                      :label="item.itemValue"
                      :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('sourceMaterial.season')" >
                  <el-select v-model="filterForm3.season" :placeholder="$t('sourceMaterial.chooseSeason')" clearable>
                    <el-option
                      v-for="item in seasonOptions"
                      :key="item.itemKey"
                      :label="item.itemValue"
                      :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="SKU" >
                  <el-input v-model="filterForm3.sku" :placeholder="$t('sourceMaterial.enterSKU')"></el-input>
                </el-form-item>
              </el-form>
              <el-form :inline="true" :model="detailFilterForm3" class="filterForm" label-width="98px" v-if="showFolderDetail3">
                <el-form-item :label="$t('sourceMaterial.fileName')" >
                  <el-input v-model="detailFilterForm3.fileName" :placeholder="$t('sourceMaterial.enterFileName')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('sourceMaterial.fileType')" >
                  <el-select v-model="detailFilterForm3.fileType" :placeholder="$t('sourceMaterial.chooseFileType')" clearable>
                    <el-option
                      v-for="item in fileTypeOptions"
                      :key="item.itemKey"
                      :label="item.itemValue"
                      :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('sourceMaterial.uploadTime')" >
                  <el-date-picker
                    v-model="detailFilterForm3.uploadTime"
                    type="date"
                    :placeholder="$t('sourceMaterial.chooseUploadTime')"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-form>
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="16">
                  <div class="filterBtns">
                    <!--
                    <el-button type="primary" @click="importData">导 入</el-button>
                    <el-button type="primary" @click="exportData">导 出</el-button>
                    -->
                    <!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                    <el-button type="primary" v-if="!showFolderDetail3" @click="onSearch('folder', 3)">{{ $t('search') }}</el-button>
                    <el-button type="primary" v-if="showFolderDetail3" @click="onSearch('detail', 3)">{{ $t('search') }}</el-button>
                    <el-button type="primary" v-if="!showFolderDetail3" @click="onReset('filterForm', 3)">{{ $t('reset') }}</el-button>
                    <el-button type="primary" v-if="showFolderDetail3" @click="onReset('detailFilterForm', 3)">{{ $t('reset') }}</el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </div>
        <div class="tableContainer">
          <el-card class="box-card">
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="12">
                <p class="title">
                  <span @click="showFolderDetail3=false">{{ $t('sourceMaterial.allSourceMaterial') }}</span>
                  <span style="color: #999" v-if="showFolderDetail3">></span>
                  <span style="color: #999" v-if="showFolderDetail3">{{ folderName }}</span>
                </p>
              </el-col>
              <el-col :span="12" v-if="!showFolderDetail3">
                <div class="filterBtns">
                  <el-checkbox v-model="chooseAllFiles3" style="margin-right: 20px">{{ $t('sourceMaterial.chooseAllSourceMaterial') }}</el-checkbox>
                  <el-button type="primary" icon="el-icon-download" @click="downloadSourceMaterial()">{{ $t('sourceMaterial.downloadSourceMaterial') }}</el-button>
                  <el-button type="primary" icon="el-icon-upload" @click="uploadSourceMaterial()">{{ $t('sourceMaterial.uploadSourceMaterial') }}</el-button>
                  <el-button type="primary" icon="el-icon-delete" @click="patchDeleteFiles()">{{ $t('sourceMaterial.patchDelete') }}</el-button>
                  <el-button type="primary" icon="el-icon-plus" @click="onAddFile()">{{ $t('sourceMaterial.createFile') }}</el-button>
                </div>
              </el-col>
              <el-col :span="12" v-if="showFolderDetail3">
                <div class="filterBtns">
                  <el-checkbox v-model="chooseAllDetails3" style="margin-right: 20px">{{ $t('sourceMaterial.chooseAllSourceMaterial') }}</el-checkbox>
                  <el-button type="primary" icon="el-icon-download" @click="downloadSourceMaterial()">{{ $t('sourceMaterial.downloadSourceMaterial') }}</el-button>
                  <el-button type="primary" icon="el-icon-upload" @click="uploadSourceMaterial()" v-if="isAdmin">{{ $t('sourceMaterial.uploadSourceMaterial') }}</el-button>
                  <el-button type="primary" icon="el-icon-delete" @click="patchDeleteDetails()" v-if="isAdmin">{{ $t('sourceMaterial.patchDelete') }}</el-button>
                  <el-button type="primary" icon="el-icon-plus" @click="onAddFile()" v-if="isAdmin">{{ $t('sourceMaterial.createFile') }}</el-button>
                </div>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <div style="margin-top: 20px">
              <ul class="fileList" v-if="!showFolderDetail3">
                <li v-for="(fileItem, index) in fileList3" @click="openFolder(fileItem.id, fileItem.name, 3)">
                  <el-checkbox v-model="fileList3[index].checked"></el-checkbox>
                  <div style="text-align: center">
                    <i class="el-icon-folder fileIcon"></i>
                  </div>
                  <span>{{ fileItem.name }}</span>
                  <el-row type="flex" class="row-bg" justify="space-between" style="margin-top: 10px">
                    <el-col :span="2"><i class="el-icon-delete" @click="deleteFile(fileItem.id)"></i></el-col>
                    <el-col :span="2"><i class="el-icon-download" @click="downloadFile(fileItem.id)"></i></el-col>
                  </el-row>
                </li>
              </ul>
              <ul class="fileList" v-if="showFolderDetail3">
                <li v-for="(detailItem, index) in detailList3">
                  <el-checkbox v-model="detailList3[index].checked"></el-checkbox>
                  <div style="text-align: center">
                    <img src="http://placekitten.com/200/200" alt="" style="width: 100%">
                  </div>
                  <span>{{ detailItem.name }}</span>
                  <el-row type="flex" class="row-bg" justify="space-between" style="margin-top: 10px">
                    <el-col :span="2"><i class="el-icon-delete" @click="deleteDetail(detailItem.id)"></i></el-col>
                    <el-col :span="2"><i class="el-icon-download" @click="downloadDetail(detailItem.id)"></i></el-col>
                  </el-row>
                </li>
              </ul>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$t('sourceMaterial.createFile')"
      :visible.sync="CreateFileDialogVisible"
      width="40%"
      center
    >
      <div style="text-align: center">
        <i class="el-icon-folder newFileIcon"></i>
      </div>
      <div>
        <el-select v-model="newFileForm.season" :placeholder="$t('sourceMaterial.season')" style="width: 20%">
          <el-option
            v-for="item in seasonOptions"
            :key="item.itemKey"
            :label="item.itemValue"
            :value="item.itemKey">
          </el-option>
        </el-select>
        _
        <el-select v-model="newFileForm.theme" :placeholder="$t('sourceMaterial.theme')" style="width: 54%">
          <el-option
            v-for="item in themeOptions"
            :key="item.itemKey"
            :label="item.itemValue"
            :value="item.itemKey">
          </el-option>
        </el-select>
        _
        <el-input v-model="newFileForm.sku" placeholder="SKU" style="width: 20%"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveFile">{{ $t('save') }}</el-button>
        <el-button type="primary" @click="CreateFileDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('sourceMaterial.uploadSourceMaterial')"
      :visible.sync="uploadDialogVisible"
      width="40%"
      center
    >
      <div>
        <span style="color: red">*</span>素材文件格式支持jpeg,png,mp4,excel,pdf(jpeg,png单个文件不超过5M; mp4单个文件不超过30M)
        <div class="uploadBox">
          <el-upload
            class="upload-demo"
            ref="upload"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            :limit="100"
            :on-exceed="handleExceed"
            :file-list="uploadFileList"
            :auto-upload="false"
            :on-change="uploadFileListChange"
          >
            <el-button size="small" type="primary" @click="submitUpload">点击上传</el-button>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitSourceMaterial">{{ $t('sourceMaterial.success') }}</el-button>
        <el-button type="primary" @click="uploadDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'SourceMaterial',
  components: {
  },
  data: function () {
    return {
      isAdmin: true, // 是否管理员
      detailFilterForm1: {
        fileName: '', // 文件名称
        fileType: '', // 文件类型
        uploadTime: '', // 上传时间
      },
      detailFilterForm2: {
        fileName: '', // 文件名称
        fileType: '', // 文件类型
        uploadTime: '', // 上传时间
      },
      detailFilterForm3: {
        fileName: '', // 文件名称
        fileType: '', // 文件类型
        uploadTime: '', // 上传时间
      },
      initDetailFilterForm: {
        fileName: '', // 文件名称
        fileType: '', // 文件类型
        uploadTime: '', // 上传时间
      },
      showFolderDetail1: false,
      showFolderDetail2: false,
      showFolderDetail3: false,
      folderName: '',
      typeList: [
        'jpg',
        'jpeg',
        'png',
        'mp4',
        'xlsx',
        'pdf'
      ],
      detailList1: [
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.mp4',
          id: '',
          checked: false,
          type: 'mp4'
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.xlsx',
          src: 'http://placekitten.com/200/200',
          checked: false,
          type: 'excel'
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.pdf',
          src: 'http://placekitten.com/200/200',
          checked: false,
          type: 'pdf'
        },
      ],
      detailList2: [
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.mp4',
          id: '',
          checked: false,
          type: 'mp4'
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.xlsx',
          src: 'http://placekitten.com/200/200',
          checked: false,
          type: 'excel'
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.pdf',
          src: 'http://placekitten.com/200/200',
          checked: false,
          type: 'pdf'
        },
      ],
      detailList3: [
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.jpg',
          id: '',
          src: 'http://placekitten.com/200/200',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.mp4',
          id: '',
          checked: false,
          type: 'mp4'
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.xlsx',
          src: 'http://placekitten.com/200/200',
          checked: false,
          type: 'excel'
        },
        {
          name: 'SP23_训练跑步系列_DV1741_1.pdf',
          src: 'http://placekitten.com/200/200',
          checked: false,
          type: 'pdf'
        },
      ],
      uploadFileList: [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}],
      newFileForm: {
        season: '', // 季节
        theme: '', // 主题
        sku: '', // sku
      },
      fileList1: [
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        }

      ],
      fileList2: [
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        }

      ],
      fileList3: [
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        },
        {
          name: 'SP23_训练跑步系列_DV1741',
          id: '',
          checked: false
        }

      ],
      chooseAllFiles1: false, // 全选素材
      chooseAllFiles2: false, // 全选素材
      chooseAllFiles3: false, // 全选素材
      chooseAllDetails1: false, // 全选
      chooseAllDetails2: false, // 全选
      chooseAllDetails3: false, // 全选
      activeName: 'first',
      uploadDialogVisible: false,
      CreateFileDialogVisible: false, // 新建文件夹弹窗
      themeOptions: [], // 主题列表
      seasonOptions: [], // 季节列表
      fileTypeOptions: [], // 文件类型列表
      filterForm1: {
        theme: '', // 主题
        season: '', // 季度
        sku: '', // sku
      },
      filterForm2: {
        theme: '', // 主题
        season: '', // 季度
        sku: '', // sku
      },
      filterForm3: {
        theme: '', // 主题
        season: '', // 季度
        sku: '', // sku
      },
      initFilterForm: {
        theme: '', // 主题
        season: '', // 季度
        sku: '', // sku
      },

      adminUserForm: {},
      initAdminUserForm: {
        cellphone: '', // 手机号
        roleCode: '', // 角色code
        doorName: '', // 门店
        posId: '', // posId
      },
      filterRegionOptions: [],
      regionOptions: [],
      resellerOptions: [],
      subResellerOptions: [],
      roleOptions: [],
      adminOptions: [{
        label: '是admin',
        value: 1
      },
        {
          label: '非admin',
          value: 0
        }],
      tableData: [], // 表格数据
      total: 0,
      tableConfig: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      tableLoading: false,
      showRegion: false,
      showReseller: false,
      showRole: false,
      disableRole: false // 新增时是否禁用选择角色
    }
  },
  mounted () {
    this.getRangList()
    this.getOptions({})
    this.onReset('filterForm', 1)
    this.onReset('filterForm', 2)
    this.onReset('filterForm', 3)
    this.onReset('detailFilterForm', 1)
    this.onReset('detailFilterForm', 2)
    this.onReset('detailFilterForm', 3)
  },
  methods: {
    deleteDetail () {
      // todo: 删除文件
    },
    downloadDetail () {
      // todo: 下载文件
    },
    openFolder(id, name, type) {
      // todo: 查看文件夹详情
      this['showFolderDetail' + type] = true
      this.folderName = name
    },
    submitUpload() {
      // todo: 需要确认是单个文件先上传到云端,还是最后一起上传
      this.$refs.upload.submit();
    },
    uploadFileListChange: function(file, fileList) {
      // todo: 上传文件列表修改
      console.log('file', file)
      console.log('fileList', fileList)
      const fileName = file.name
      const fileType = fileName.split('.')[1]
      if(_.indexOf(fileType, this.typeList) === -1) {
        this.$message.warning('上传文件格式不符')
        console.log('this.uploadFileList', this.uploadFileList)
        this.uploadFileList = fileList
        this.uploadFileList.pop();
      }
    },
    submitSourceMaterial: function() {
      // todo: 上传素材
    },
    downloadFile: function () {
      // todo: 下载文件
    },
    deleteFile: function () {
      // todo: 删除文件
    },
    saveFile: function () {
      // todo: 保存新建文件夹
    },
    downloadSourceMaterial: function() {
      // todo: 下载素材
    },
    uploadSourceMaterial: function() {
      this.uploadDialogVisible = true
    },
    patchDeleteFiles: function () {
      // todo: 批量删除文件夹
    },
    patchDeleteDetails: function () {
      // todo: 批量删除文件夹内的素材
    },
    onAddFile: function () {
      this.CreateFileDialogVisible = true
    },
    downloadFailure: function() {
      // todo: 下载导入失败列表
    },

    // 获取弹窗里的区域,客户,角色列表
    getOptions: async function (params) {
      let res = await window.instance.post(window.surveyUrl + '/condition/user', params)
      console.log('res', res)
      res = res.data.data
      this.regionOptions = _.map(res.regionList, (item) => ({label: item.itemValue, value: item.itemKey}))
      this.roleOptions = _.map(res.roleList, (item) => ({label: item.itemValue, value: item.itemKey}))
      this.resellerOptions = _.map(res.resellerList, (item) => ({label: item.itemValue, value: item.itemKey}))
    },
    // 获取筛选条件的区域,地区列表
    getRangList: async function () {
      let res = await window.instance.post(window.retailogUrl + '/account/common', {})
      res = res.data.data
      this.filterRegionOptions = res.regionList
      this.locateOptions = res.locateList
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      this.tableLoading = true
      let res = await window.instance.post(window.surveyUrl + '/account/list', _.assign(this.filterForm2, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        const list = res.data.list
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },
    currentChange: function (index) {
      // 分页
      this.tableConfig.current = index
      this.onSearch(false)
    },
    onReset: function (type, num) {
      if (type === 'filterForm') {
        this[type + num] = _.cloneDeep(this.initFilterForm)
      } else {
        console.log('type+num', type + num)
        this[type + num] = _.cloneDeep(this.initDetailFilterForm)
      }
    },

    // todo: 导入用户
    importData: function () {

      // 如果失败的话,弹出失败列表
      this.failureDialogVisible = true
      this.failureTableData = [{
        name: '张三',
        role: '角色',
        cellphone: '13888888888',
        regionName: '大北京',
        resellerName: '客户',
        subResellerName: '二级客户',
        failureReason: '失败原因'
      }]
    },
    // todo: 导出用户
    exportData: function () {
    },
    getSelectedName: function (no, list) {
      if (!no) {
        return null
      }
      const selectedReseller = _.find(list, function (data) { return data.value === no })
      if (selectedReseller) {
        return selectedReseller.label
      } else {
        return false
      }
    }
  },
  watch: {
    chooseAllFiles1(val,oldVal) {
      console.log('val', val)
      if (val) {
        _.each(this.fileList1, (file, index) => {
          file.checked = true
        })
      } else {
        _.each(this.fileList1, (file, index) => {
          file.checked = false
        })
      }
    },
    chooseAllFiles2(val,oldVal) {
      console.log('val', val)
      if (val) {
        _.each(this.fileList2, (file, index) => {
          file.checked = true
        })
      } else {
        _.each(this.fileList2, (file, index) => {
          file.checked = false
        })
      }
    },
    chooseAllFiles3(val,oldVal) {
      console.log('val', val)
      if (val) {
        _.each(this.fileList3, (file, index) => {
          file.checked = true
        })
      } else {
        _.each(this.fileList3, (file, index) => {
          file.checked = false
        })
      }
    },
    chooseAllDetails1(val,oldVal) {
      console.log('val', val)
      if (val) {
        _.each(this.detailList1, (file, index) => {
          file.checked = true
        })
      } else {
        _.each(this.detailList1, (file, index) => {
          file.checked = false
        })
      }
    },
    chooseAllDetails2(val,oldVal) {
      console.log('val', val)
      if (val) {
        _.each(this.detailList2, (file, index) => {
          file.checked = true
        })
      } else {
        _.each(this.detailList2, (file, index) => {
          file.checked = false
        })
      }
    },
    chooseAllDetails3(val,oldVal) {
      console.log('val', val)
      if (val) {
        _.each(this.detailList3, (file, index) => {
          file.checked = true
        })
      } else {
        _.each(this.detailList3, (file, index) => {
          file.checked = false
        })
      }
    }
  }
}
</script>

<style scoped lang="sass">
#sourceMaterial
  .uploadBox
    border: 1px solid #ccc
    padding: 10px
    height: 400px
    margin-top: 20px
  .newFileIcon
    font-size: 120px
    color: #ff6801
  .filterConditionContainer
    margin-top: 30px
  .tableContainer
    margin-top: 20px
    .title
      font-size: 14px
      line-height: 38px
    .fileList
      display: flex
      flex-wrap: wrap
      li
        width: calc(14.28% - 20px)
        margin-right: 20px
        margin-bottom: 20px
        background: #f1f1f1
        padding: 10px
        position: relative
        label
          position: absolute
          right: 10px
          top: 7px

      .fileIcon
        font-size: 100px
        text-align: center
        color: #ff6801
  .roleName
    color: #ff6801
    margin-left: 32px
    margin-bottom: 20px
  .roleCode
    margin-left: 32px
    margin-bottom: 14px
    label
      padding: 5px 0
</style>



// WEBPACK FOOTER //
// src/pages/wo/sourceMaterialManage.vue